<template>
    <div class="financeApplication__progress">
        <div class="financeApplication__progress__bar">
            <span class="financeApplication__progress__fill" :style="styleObject"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentStep: {
            type: Number,
            default: 0
        },
        totalSteps: {
            type: Number,
            default: 1
        }
    },

    computed: {
        styleObject() {
            return {
                width: (this.currentStep / this.totalSteps * 100) + '%'
            }
        }
    }
}
</script>
